<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackToTop_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M1.656 1a.656.656 0 1 0 0 1.313h12.688a.656.656 0 0 0 0-1.313H1.656ZM3.84 7.685l3.663-3.628a.737.737 0 0 1 1.036 0l3.663 3.628a.72.72 0 0 1 0 1.026.737.737 0 0 1-1.036 0L8.802 6.37l-.036 7.864c0 .406-.289.766-.699.766s-.74-.36-.74-.766v-7.95L4.876 8.71a.737.737 0 0 1-1.036 0 .72.72 0 0 1 0-1.026Z"
        clip-rule="evenodd"
    />
</svg>
